import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../../diccionarios/empModulo';
import { PuntoEntregaModel } from '../../models/puntoEntregaModel';
import { CaracteristicaModel } from '../../models/caracteristicaModel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrearEmpleadoService {

  diccionarioUrl: any;
  urlNomina: string;
  diccionarioUrl_pe: any;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlNomina = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.epp.administrador;
    this.diccionarioUrl_pe = empModulo.url.epp.puntoEntrega;
  }

  
  //Empleados
  validateCedula(cedula:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.findCedulaValidar+"/"+cedula );
  }

  //Empleados
  findEmpleados(cedula:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.findEmpleado+"/"+cedula );
  }
  //CrearEmpleado o Editar
  sendEmpleado(empleado:any){
    return this.commom.peticionPostConHeader(this.urlNomina+this.diccionarioUrl.findEmpleado+"/create/"+empleado.loguedUser,empleado);
  }

  //obtenerProvincias
  getAllProvincias(){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.getProvincias);
  }

  getAllEmpresas() {//: Observable<DatosColaboradores> {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getEmpresas);
  }

  getAllEmpresaSolicita() {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getEmpresaSolicita);
  }

  getCantones(value:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.getCantones+"/"+value);
  }

  //cargos
  getAllCargos() {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getCargos);
  }

  getAllDepartamentos(){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getDepartamento);
  }

  getDepartamentoByEmpresa(empresa:string){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getDepartamento+"/"+empresa);
  }

  getEmpleadosByDepAndEmp(dep:string,emp:string){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getEmployesByDepEmp+"/"+dep+"/"+emp);
  }

  getAllLocalidades(){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getLocalidad);
  }

  getAllCodigoCostos(){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getCodigoCosto);
  }

  uploadFile(formData: FormData): Observable<any[]> {
    //let str = 'http://localhost:8080/nomina/nomina/v1/api/services/empleado/readDocument';
    //return this.commom.peticionPost(str, formData);
    return this.commom.peticionPostConHeader(this.urlNomina + this.diccionarioUrl.readDocument, formData);
  }

  getAllEmpleadoEmpresa(empresa: string){
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.empleadoEmpresa + empresa);
  }

  updateType(listEmpeados: any) {
    return this.commom.peticionPutConHeader(this.urlNomina + this.diccionarioUrl.updateType, listEmpeados);
  }

  updateEmpleadoCustom(empleado: any) {
    return this.commom.peticionPutConHeader(this.urlNomina + this.diccionarioUrl.updateEmpleadoCustom, empleado);
  }
  
  updateEmpleadoCustomList(empleados: any[]) {
    return this.commom.peticionPutConHeader(this.urlNomina + this.diccionarioUrl.updateEmpleadoCustomList, empleados);
  }

  deleteEmpleado(codeEmpleado: string) {
    ///nomina/v1/api/services/empleado/{codEmpleado}
    return this.commom.peticionDeleteConHeader(this.urlNomina + this.diccionarioUrl.findEmpleado + '/' + codeEmpleado);
  }

  findEmpleadosCedula(cedula:string){
    return this.commom.peticionGetConHeader(this.urlNomina+this.diccionarioUrl.findEmpleado + "/"+cedula );
  }

  createHitoHistorial(innEmpleado: any) {
    //nomina/v1/api/services/empleado/historial
    return this.commom.peticionPostConHeader(this.urlNomina + this.diccionarioUrl.createHistorial, innEmpleado);
  }

  getAllDocumentos() {
    //nomina/v1/api/services/empleado/historial
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.sstma);
  }

  getAllRechazados() {
    //nomina/v1/api/services/empleado/historial
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.sstmaRechazado);
  }

  getAllAprobados() {
    //nomina/v1/api/services/empleado/historial
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.sstmaAprobado);
  }

  saveDocumentos(innObj: any) {
    //nomina/v1/api/services/empleado/historial
    return this.commom.peticionPostConHeader(this.urlNomina + this.diccionarioUrl.sstma, innObj);
  }

  getReporteHoras() {
    // sstmaReporte
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.sstmaReporte);
  }

  descargarDocumento() {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.sstmaReportDownload);
  }

  createHistorialList(listHistorial: any[]) {
    return this.commom.peticionPostConHeader(this.urlNomina + this.diccionarioUrl.createHistorialList, listHistorial);
  }

  getEmployesByDepEmpColaborador(codDep: string, codEmpresa: string) {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getEmployesByDepEmpColaborador + codDep + '/'+ codEmpresa);
  }

  empleadoEmpresaColaborador(codEmpresa: string) {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.empleadoEmpresaColaborador + codEmpresa);
  }

  // getEmployesByDepEmpColaborador:'/services/empleado/depaEmpresa/colaborador/',
  // empleadoEmpresaColaborador: 'services/empleado/empresa/colaborador/',
  
}
